import React from 'react';

import { useLocation, useParams } from 'react-router';
import { RateCardDetail, steps } from 'src/components/RateCardDetail';
import { ROUTES } from 'src/constants/routes';
import { useDynamicRedirect } from 'src/hooks';
import { IRateCardDetailParams } from 'src/types/IRateCard';

/**
 * Wrapper for <RateCardDetail /> that derives component props from input parameters.
 *
 * This allows <RateCardDetail /> to be configured (mostly) independently of
 * the current path.
 */
export const RateCardDetailWrapper: React.FC = () => {
    const { pathname } = useLocation();

    const params: IRateCardDetailParams = useParams();
    const rateCardId = parseInt(params.rateCardId);

    const [isEditMode] = React.useState<boolean>(
        !!rateCardId && (pathname.includes(ROUTES.RATE_CARDS.EDIT) || pathname.includes(ROUTES.RATE_CARDS.ADD))
    );
    // Use '/add' route for editing a draft rate card
    const [isEditDraft] = React.useState<boolean>(!!rateCardId && pathname.includes(ROUTES.RATE_CARDS.ADD));

    const baseEditPath = `${ROUTES.RATE_CARDS.INDEX}/${params.editType}/${params.rateCardId}`;

    useDynamicRedirect(baseEditPath, steps[0].stepId);

    return <RateCardDetail rateCardId={rateCardId} isEditMode={isEditMode} isEditDraft={isEditDraft} />;
};
